const {ffToBasicInput} = require("./ff-to-basic-input");

exports.ffToNumberInput = ffToBasicInput;
